import { Component, OnInit, Input } from '@angular/core';
import { UntypedFormGroup, FormControl, Validators, FormControlName} from '@angular/forms';
import { numberValidator } from 'src/app/_validators';
import { Observable } from 'rxjs';
import { ActualizacionDatosService } from '../actualizacion-datos.service';
import { PersonaUpdate } from 'src/app/_models/persona-update';

@Component({
  selector: 'app-datos-padres',
  standalone: false,
  templateUrl: './datos-padres.component.html',
  styleUrls: ['./datos-padres.component.scss', '../actualizacion_datos.scss']
})
export class DatosPadresComponent implements OnInit {

  @Input()
  datosPadresForm: UntypedFormGroup;

  public documentos$: Observable<any>;

  public ciudades$: Observable<any>;

  constructor(private actualizacionService: ActualizacionDatosService) { }

  ngOnInit() {
    this.ciudades$ = this.actualizacionService.ciudades$;
    this.documentos$ = this.actualizacionService.documentos$;
  }

  getErrorMessage(controlPath: string) {
    const control = this.datosPadresForm.get(controlPath);
    return control.hasError('required') ? 'Este campo es requerido' :
        control.hasError('email') ? 'No es un email valido' :
        control.hasError('invalidNumber') ? 'No es un número valido' :
        control.hasError('invalidPhone') ? 'No es un número de telephono valido' :
            '';
  }

}
